module.exports = __webpack_public_path__ + "img/Lasagna_Meal_Beef_Bolognese.beea9ecf.jpg";